const MAX_SIZE = 50;

export class LRUCache {

  _maxSize;

  constructor (size = MAX_SIZE) {
    this._maxSize = size;
    this.cache = new Map();
  }

  getOrCreate (key, creatorCbk) {
    let item = this.get(key);
    if (!item) {
      item = creatorCbk();
      this.set(key, item);
    }
    return item;
  }

  get (key) {
    const item = this.cache.get(key);
    if (item) {
      // refresh key
      this.cache.delete(key);
      this.cache.set(key, item);
    }
    return item;
  }

  set (key, val) {
    if (this.cache.has(key)) {
      this.cache.delete(key); // delete existing key, there will be a newer val with the same key in the cache
    } else if (this.cache.size === this._maxSize) {
      // If we reached maxSize, delete the oldest item
      const oldestKey = this.cache.keys().next().value;
      this.cache.delete(oldestKey);
    }
    this.cache.set(key, val);
  }

}
